import { PHASE } from "../../routeConfig";
import { InsuranceType } from "../../constants";
import { createSelector } from "@reduxjs/toolkit";
import useAppSelector from "../../hooks/useAppSelector";
import { v4 as uuid } from "uuid";
var entryRouteSelector = createSelector([function (state) { return state.unlinkedApplication; }], function (unlinkedApplication) {
    var hasUnlinkedVehicles = unlinkedApplication.auto.vehicles.length > 0;
    var v2AutoEntryRoute = hasUnlinkedVehicles
        ? PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES
        : PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_YEAR.replace(":vehicleId", uuid());
    return v2AutoEntryRoute;
});
export default function useUnlinkedApplicationEntryRoute(insuranceType) {
    if (insuranceType === void 0) { insuranceType = InsuranceType.Auto; }
    var v2AutoEntryRoute = useAppSelector(entryRouteSelector);
    if (insuranceType === InsuranceType.Home) {
        return PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PROPERTY_ADDRESS;
    }
    return v2AutoEntryRoute;
}
